import { TABLE_FILTER_BAR_LABELS } from './labels'

export const TABLE_HEADER_HEIGHTS = {
  main: 48,
  group: 32,
} as const

export const TABLE_ROW_HEIGHTS = {
  single: 52,
  compactDouble: 64,
  double: 72,
} as const

export const TABLE_COLUMN_WIDTHS = {
  xxs: 50,
  xs: 80,
  sm: 120,
  md: 160,
  lg: 260,
  xl: 360,
} as const

/** Column mins that are not a TABLE_COLUMN_WIDTHS step. */
export const TABLE_COLUMN_MIN_WIDTHS = {
  dataLocation: 150,
} as const

/** Conservative estimate of an AgDataTable's filter bar including its surrounding margins. */
export const TABLE_FILTER_BAR_HEIGHT = 112

export const TABLE_TOOLTIP_SHOW_DELAY_MS = 500

/** Analytics event used when a table doesn't supply its own filter-apply event name. */
export const DEFAULT_FILTER_TRACKING_EVENT = 'generic.filter.apply'

/** Settle time after a frame before running a deferred grid update. */
export const DEFERRED_UPDATE_DELAY_MS = 50

// AgGroupTable sizing
export const DETAIL_GRID_ROW_HEIGHT = TABLE_ROW_HEIGHTS.single
export const MASTER_ROW_HEIGHT = TABLE_ROW_HEIGHTS.single
/** Height assumed for a detail grid before its real content height is known. */
export const FALLBACK_DETAIL_HEIGHT = 200
/** Ceiling on a panel's height. A definite height is what lets the detail grid virtualise; below it
 * a panel is still exactly as tall as its rows. */
export const MAX_DETAIL_PANEL_HEIGHT = 600
export const DEFAULT_GROUP_TABLE_HEIGHT = 'h-[560px]'

export const CSV_FORMULA_TRIGGER = /^[=+\-@\t\r]/
export const CSV_PLAIN_NUMBER = /^[+-]?\d+(\.\d+)?$/

/** The label used to represent empty/null values in AG Grid set filters. */
export const EMPTY_FILTER_VALUE = '(empty)'

/** Filled neutral chip used when a filter sits next to an attached "remove" button. */
export const ATTACHED_UNSELECTED = 'bg-main-background-neutral hover:bg-main-background-muted-dark'

/** Test fixture: a view whose filter model pins status to "Dismissed". */
export const TEST_VIEW_STATUS_FILTER = { status: { filterType: 'set', values: ['Dismissed'] } }

export const GROUP_TABLE_TEST_ROWS = [
  { id: '1', name: 'Item 1', category: 'A' },
  { id: '2', name: 'Item 2', category: 'A' },
  { id: '3', name: 'Item 3', category: 'B' },
]

export const ROW_GROUP_TABLE_TEST_ROWS = [
  { id: '1', name: 'Item 1', category: 'A' },
  { id: '2', name: 'Item 2', category: 'A' },
  { id: '3', name: 'Item 3', category: 'B' },
]

// Canonical URL param keys for all tables
export const CANONICAL_PARAM_KEYS = {
  view: 'VIEW',
  filter: 'FILTER',
  sort: 'SORT',
  search: 'SEARCH',
  columns: 'COLUMNS',
  grouped: 'GROUPED',
  // Legacy params that are folded into FILTER and removed on write
  legacyRisk: 'RISK',
  legacyStatus: 'STATUS',
} as const

// Rolling: a preset is kept by name in the filter model and resolved against today on every check.
export const DATE_FILTER_PRESETS = [
  { value: 'last7Days', label: TABLE_FILTER_BAR_LABELS.datePresets.last7Days, days: 7 },
  { value: 'last30Days', label: TABLE_FILTER_BAR_LABELS.datePresets.last30Days, days: 30 },
  { value: 'last90Days', label: TABLE_FILTER_BAR_LABELS.datePresets.last90Days, days: 90 },
  { value: 'last12Months', label: TABLE_FILTER_BAR_LABELS.datePresets.last12Months, days: 365 },
] as const
